// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YB8-","content":"styles_content__2ihwg"};